import * as t from 'io-ts';

export const UsernamePasswordSchema = t.exact(t.interface({
    username: t.string,
    password: t.string,
}));

export interface UsernamePassword extends t.TypeOf<typeof UsernamePasswordSchema> {}
